var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AppLayout',[_c('Nuxt'),_vm._v(" "),_c('AppOfflineBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }